import { Id, ReadonlyCollectionRepository } from '../abstraction';
import { createHttpResourceLocation } from '../../data-access/types/http.location';
import { HttpDataAccess } from '../../data-access/http.data-access';
import { Dictionary } from '../../types/dictionary';
import { toIdString } from '../functions/to-id-string';

export abstract class ReadonlyHttpCollectionRepository<TResult, TLoadParams = undefined> implements ReadonlyCollectionRepository<TResult, TLoadParams> {

  protected constructor(protected dataAccess: HttpDataAccess,
                        protected url: string) { }

  load(params: TLoadParams): Promise<TResult> {
    const location = createHttpResourceLocation({
      url: this.url,
      pathParams: this.getLoadPathParams(params),
      queryParams: this.getLoadQueryParams(params)
    });
    const payload = this.getLoadPayload(params);
    return this.dataAccess.get(location, payload);
  }

  protected abstract getLoadPathParams(params: TLoadParams): Dictionary<unknown> | undefined;
  protected abstract getLoadQueryParams(params: TLoadParams): Dictionary<unknown> | undefined;
  protected abstract getLoadPayload(params: TLoadParams): unknown | undefined;
}
